<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Claim No. Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doCancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-flex class="mt-3" xs12>
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-data-table
              v-bind:headers="headers"
              v-bind:items="items"
              v-bind:search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              item-key="docNo"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
              v-model="selected"
            >
              <template v-slot:item="row"
                ><tr>
                  <td width="50px">
                    <!-- <v-checkbox primary hide-details v-model="row.selected"></v-checkbox> -->
                    <input type="checkbox" primary hide-details v-model="row.selected" @click="selectData(row.item)" />
                  </td>
                  <td class="text-xs-left">{{ row.item.branch }}</td>
                  <td class="text-xs-left">{{ row.item.claimNo }}</td>
                  <td class="text-xs-left">{{ row.item.tranType }}</td>
                  <td class="text-xs-left">{{ row.item.docNo }}</td>
                </tr></template
              >
            </v-data-table>
          </v-card-text>
        </v-card>
        <div class="pt-2">
          <v-btn color="error" dark class=" mr-2" @click.prevent="doCancel">
            Cancel
            <v-icon dark right>mdi-cancel</v-icon></v-btn
          >
          <v-btn color="primary" dark class=" mr-2" @click="doSelect">
            Select
            <v-icon right>mdi-checkbox-marked-circle-outline</v-icon>
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import addDays from 'date-fns/addDays'
import { formatDisplayDateTime2, removeTime } from '@/utils/date'

export default {
  data() {
    return {
      headers: [
        { text: '', value: 'checkbox' },
        { text: 'Branch', value: 'branch' },
        { text: 'Claim No.', value: 'claimNo' },
        { text: 'Tran Type ', value: 'tranType' },
        { text: 'Document', value: 'docNo' }
      ],
      selected: [],
      reportClaimNo: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.claimReports.menu
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.claimReports.init !== 1) {
          await this.$store.dispatch('claimReportsInit')
        }
        const apiURI = this.rptMenu.claimDoc
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result
          if (data) {
            // return as a menu list
            this.menu = extractMenu(result.data._links)
            if (this.menu) {
              this.doFetchClaimNo()
            }
          }
        }
      } catch (err) {
        throw err
      }
    },
    async doFetchClaimNo() {
      const apiURI = this.menu.getClmPaytList
      if (apiURI) {
        this.loading = true
        let enteredOnDateFrom = ''
        let enteredOnDateTo = ''
        // this.$http.get(apiURI).then(result => {
        if (this.enteredDate !== null && this.enteredDate !== '') {
          enteredOnDateFrom = formatDisplayDateTime2(removeTime(this.enteredDate - 1))
          enteredOnDateTo = formatDisplayDateTime2(removeTime(addDays(this.enteredDate, 1)))
          // enteredOnDate = this.enteredDate
        }
        const expand = {
          enteredDateFrom: enteredOnDateFrom,
          enteredDateTo: enteredOnDateTo,
          branch: this.brn,
          department: this.dept
        }
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            this.items = []
            this.claimNoItem = []
            const { data } = result.data
            if (data) {
              data.map((claimNoList) => {
                const convertList = {
                  branch: claimNoList.branch,
                  claimNo: claimNoList.clmNo,
                  tranType: claimNoList.tranType1,
                  docNo: claimNoList.docNo
                }
                this.items.push(convertList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    selectData(data) {
      this.selected = []
      const resultList = {
        branch: data.branch,
        claimNo: data.claimNo,
        tranType: data.tranType,
        docNo: data.docNo
      }
      this.selected.push(resultList)
    },
    doSelect() {
      const selectedItems = []
      selectedItems.push(this.selected[0].claimNo)
      const claimNoObj = {
        selectedItems: selectedItems,
        totalLength: this.items.length,
        from: this.wClm
      }
      this.$emit('doAssign', claimNoObj)
      this.$emit('close')
    },
    doCancel() {
      this.$emit('close')
    }
  },
  mixins: [TableConst.default, MessageMixin],
  props: {
    brn: {
      type: String,
      default: ''
    },
    dept: {
      type: String,
      default: ''
    },
    enteredDate: {
      type: Date,
      default: null
    },
    wClm: {
      type: String,
      default: ''
    }
  }
}
</script>
